var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8917 11.1333C22.1254 11.3676 22.2569 11.6856 22.257 12.0165C22.2569 12.3476 22.125 12.6661 21.891 12.9004L14.3911 20.4003C14.1568 20.6343 13.8384 20.7662 13.5072 20.7663C13.1763 20.7662 12.8583 20.6347 12.6241 20.401C12.3902 20.1668 12.2582 19.8481 12.2581 19.5171C12.2581 19.1858 12.39 18.8676 12.6241 18.6332L17.9909 13.2664L3.00768 13.2664C2.67632 13.2664 2.35818 13.1346 2.1238 12.9004C1.88946 12.6661 1.7579 12.3479 1.75781 12.0165C1.75788 11.6851 1.88875 11.3663 2.12311 11.1319C2.3575 10.8977 2.67629 10.7666 3.00768 10.7666L17.9895 10.7667L12.6234 5.40051L12.6247 5.39913C12.5081 5.28729 12.413 5.15458 12.3472 5.00691C12.2789 4.85368 12.2417 4.6878 12.2387 4.52008C12.2358 4.35232 12.2671 4.18538 12.3299 4.0298C12.3928 3.87423 12.4861 3.73275 12.6047 3.6141C12.7234 3.49545 12.8648 3.40214 13.0204 3.33927C13.176 3.27645 13.3429 3.24516 13.5107 3.24812C13.6784 3.25112 13.8443 3.28826 13.9975 3.35653C14.1452 3.42242 14.2779 3.51748 14.3898 3.63412L14.3911 3.63274L21.8917 11.1333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.01f3a70ffec561c254abd475f7c46e0e.svg";
export { ForwardRef as ReactComponent };